import { render } from "./App.vue?vue&type=template&id=7f45d282&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7f45d282&lang=css"
import "./App.vue?vue&type=style&index=1&id=7f45d282&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/lauron-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f45d282"]])

export default __exports__